// eslint-disable-next-line unicorn/filename-case
import { useMemo, useRef } from 'react'
import { useTokenInventory } from '@vatom/sdk/react'

export interface IUseToken {
  tokenId: string
}

export const useToken = ({ tokenId }: IUseToken) => {
  const { token: theToken, isLoading } = useTokenInventory(tokenId)
  const prevToken = useRef(theToken)

  const shouldRerender = prevToken.current?.id !== theToken?.id
  const token = useMemo(() => {
    if (theToken && shouldRerender) {
      prevToken.current = theToken
    }
    return prevToken.current
  }, [shouldRerender, theToken])

  return {
    token,
    isLoading
  }
}
